import { mangeApi } from '@/plugins/mangeAxios'

export async function getAdvertList (params) {
  const result = await mangeApi('/advert_location/advert_list', params)
  return result.data
}